import {
  MovementBeneficiaryTypeEnum,
  MovementStatusEnum,
  OperationStatusEnum,
  PartnerCompaniesTypeEnum,
  PlanTypeEnum,
  UserProfileEnum,
  UserStatusEnum,
} from './mappedParamsEnums';

export const MOVEMENT_BENEFICIARY_TYPE_NAME: Record<
  MovementBeneficiaryTypeEnum,
  string
> = {
  [MovementBeneficiaryTypeEnum.RESPONSIBLE]: 'Responsável sem direito',
  [MovementBeneficiaryTypeEnum.DEPENDENT]: 'Dependente',
  [MovementBeneficiaryTypeEnum.HOLDER]: 'Titular',
  [MovementBeneficiaryTypeEnum.AGGREGATE]: 'Agregado',
};

export const USER_STATUS_NAME: Record<UserStatusEnum, string> = {
  [UserStatusEnum.PENDING]: 'Pendente',
  [UserStatusEnum.ACTIVE]: 'Ativo',
  [UserStatusEnum.ERROR]: 'Erro ao processar',
  [UserStatusEnum.PROCESSING]: 'Em processamento',
};

export const PLAN_TYPE_NAME: Record<PlanTypeEnum, string> = {
  [PlanTypeEnum.HEALTH]: 'Saúde',
  [PlanTypeEnum.DENTAL]: 'Odonto Puro',
  [PlanTypeEnum.HEALTH_DENTAL]: 'Saúde + Odonto',
};

export const USER_PROFILE_NAME: Record<UserProfileEnum, string> = {
  [UserProfileEnum.ADM]: 'Administrador',
  [UserProfileEnum.FINANCIAL]: 'Financeiro',
  [UserProfileEnum.MOVEMENT]: 'Movimentação',
  [UserProfileEnum.MASTER]: 'Master',
};

export const PARTNER_COMPANIES_TYPE_NAME: Record<
  PartnerCompaniesTypeEnum,
  string
> = {
  [PartnerCompaniesTypeEnum.MOTHER]: 'Mãe',
  [PartnerCompaniesTypeEnum.CHILD]: 'Filho',
};

export const MOVEMENT_STATUS_NAME: Record<MovementStatusEnum, string> = {
  [MovementStatusEnum.PROCESS_FILE_WITH_PENDENCY]:
    'Processamento com pendência',
  [MovementStatusEnum.FILE_PROCESSED_WITH_REVIEW]: 'Finalizado com críticas',
  [MovementStatusEnum.UNABLE_TO_START]: 'Impossível iniciar',
  [MovementStatusEnum.PROCESS_FILE]: 'Em processamento',
  [MovementStatusEnum.ERROR]: 'Interrompido por erro',
  [MovementStatusEnum.FILE_PROCESSED]: 'Finalizado',
  [MovementStatusEnum.NOT_STARTED]: 'Não iniciado',
};

export const OPERATION_STATUS_NAME: Record<OperationStatusEnum, string> = {
  [OperationStatusEnum.TYPED]: '0 - Digitado',
  [OperationStatusEnum.PENDING_DOCUMENTATION]: '1 - Pendente documentação',
  [OperationStatusEnum.CANCELLED]: '2 - Cancelado',
  [OperationStatusEnum.AUTHORIZED]: '8 - Autorizado',
  [OperationStatusEnum.PROCESSED]: '9 - Processado',
  [OperationStatusEnum.DATA_UNDER_VALIDATION]: '17 - Dados em validação',
};
